<template>
    <div>
        <div v-if="loader" class="d-flex justify-content-center" style="">
            <div class="spinner-border loader-center" role="status">
                <span class="sr-only text-teal">Loading...</span>
            </div>
        </div>
        <form :class="loader ? 'opacity-25' : ''">
            <div class="flex justify-between items-center text-teal hover:text-teal-dark font-base text-sm mb-4">
                <div class="flex cursor-pointer">
                <!--<span class="material-icons">chevron_left</span>-->
                <!--<span>Back</span>-->
                </div>
                <button @click.prevent="saved()" type="button" class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    Save
                </button>
            </div>
            <div class="flex justify-between items-start mb-4 flex-wrap flex-lg-nowrap">
                <div class="flex-col w-full lg:w-1/3 lg:mx-1">
                    <div class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Project Information</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex">
                                <div class="leading-tight mr-2 w-1/2">
                                    <input type="checkbox" id="name" name="name" v-model="form.name">
                                    <label class="text-grey-darkest text-sm"
                                           for="name">Project Name</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                                <div class="leading-tight w-1/2">
                                    <input type="checkbox" id="bid_bond" name="bid_bond" v-model="form.bid_bond">
                                    <label class="text-grey-darkest text-sm"
                                           for="state">Bid Bond</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                            </div>


                            <div class="flex">
                                <div class="leading-tight mr-2 w-1/2">
                                    <input type="checkbox" id="address" name="address" v-model="form.address">
                                    <label class="text-grey-darkest text-sm"
                                           for="address">Address</label>
                                    <div class="text-red text-xs">
                                    </div>
                                </div>
                                <div class="leading-tight mr-2 ml-2 w-1/2">
                                    <input type="checkbox" id="city" name="city" v-model="form.city">
                                    <label class="text-grey-darkest text-sm"
                                           for="city">City</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                            </div>

                            <div class="flex">

                                <div class="leading-tight w-1/2">
                                    <input type="checkbox" id="state" name="state" v-model="form.state">
                                    <label class="text-grey-darkest text-sm"
                                           for="state">State</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                                <div class="leading-tight ml-2 w-1/2 pr-1">
                                    <input type="checkbox" id="zip" name="zip" v-model="form.zip">
                                    <label class="text-grey-darkest text-sm"
                                           for="zip">Zip</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                            </div>
                            <div class="flex">
                                <div class="leading-tight mr-2 w-1/2">
                                    <div class="">
                                        <input type="checkbox" id="contact_name" name="contact_name" v-model="form.contact_name">
                                        <label class="text-grey-darkest text-sm"
                                               for="contact_name">Contact Name</label>

                                        <div class="text-red text-xs" >

                                        </div>

                                    </div>
                                </div>
                                <div class="leading-tight  w-1/2">
                                    <input type="checkbox" id="contact_email" name="contact_email" v-model="form.contact_email">
                                    <label class="text-grey-darkest text-sm"
                                           for="contact_email">Email</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>

                            </div>

                            <div class="flex">
                                <div class="leading-tight mr-2 w-1/2">
                                    <input type="checkbox" id="contact_phone" name="contact_phone" v-model="form.contact_phone">
                                    <label class="text-grey-darkest text-sm"
                                           for="contact_phone">Phone</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                                <div class="leading-tight w-1/2">
                                    <input type="checkbox" id="contact_cell" name="contact_cell" v-model="form.contact_cell">
                                    <label class="text-grey-darkest text-sm"
                                           for="contact_cell">Cell</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                            </div>
                            <div class="flex">
                                <div class="leading-tight w-1/2 pr-1">
                                    <input type="checkbox" id="contact_fax" name="contact_fax" v-model="form.contact_fax">
                                    <label class="text-grey-darkest text-sm"

                                           for="contact_fax">Fax</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Prequalifications</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="relate_and_connect_id" name="relate_and_connect_id" v-model="form.relate_and_connect_id">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center" for="relate_and_connect_id">Relate & Connect</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="rules_of_engagement_id" name="rules_of_engagement_id" v-model="form.rules_of_engagement_id">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center" for="rules_of_engagement_id">Rules of Engagement</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                            </div>

                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="find_problems_id" name="find_problems_id" v-model="form.find_problems_id">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="find_problems_id">Find Problems</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="money_step_id" name="money_step_id" v-model="form.money_step_id">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="money_step_id">Money Step</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="decision_process_id" name="decision_process_id" v-model="form.decision_process_id">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="decision_process_id">Decision Process</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rounded bg-white shadow-md">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Record Details</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex align-items-center mb-2">
                                <div class="leading-tight mr-2 w-1/2 flex align-items-center">
                                    <input type="checkbox" id="base_bid" name="base_bid" v-model="form.base_bid" @change="checkRecordDetailData($event, 'base-bid')">
                                    <label class="text-grey-darkest text-sm mb-0 ml-1" for="base_bid">{{ getFieldLabel(recordDetailFieldLabels, 'base-bid')}}</label>
                                </div>
                                <div class="leading-tight w-1/2 flex align-items-center">
                                    <input type="checkbox" id="contract_amount" name="contract_amount" v-model="form.contract_amount" @change="checkRecordDetailData($event, 'contract-amount')">
                                    <label class="text-grey-darkest text-sm mb-0 ml-1" for="contract_amount">{{ getFieldLabel(recordDetailFieldLabels, 'contract-amount')}}</label>
                                </div>
                            </div>
                            <div class="flex align-items-center mb-2">
                                <div class="leading-tight mr-2 w-1/2 flex align-items-center">
                                    <input type="checkbox" id="contract_date" name="contract_date" v-model="form.contract_date" @change="checkRecordDetailData($event, 'contract-date')">
                                    <label class="text-grey-darkest text-sm mb-0 ml-1">{{ getFieldLabel(recordDetailFieldLabels, 'contract-date')}}</label>
                                </div>
                                <div class="leading-tight w-1/2 flex align-items-center">
                                    <input type="checkbox" id="gross_margin_percentage" name="gross_margin_percentage" v-model="form.gross_margin_percentage" @change="checkRecordDetailData($event, 'gross-margin')">
                                    <label class="text-grey-darkest text-sm mb-0 ml-1" for="gross_margin_percentage">{{ getFieldLabel(recordDetailFieldLabels, 'gross-margin')}} %</label>
                                </div>
                            </div>
                            <div class="flex align-items-center mb-2">
                                <div class="leading-tight pr-1 w-1/2 flex align-items-center">
                                    <input type="checkbox" id="labor_hours" name="labor_hours" v-model="form.labor_hours" @change="checkRecordDetailData($event, 'labor-hours')">
                                    <label class="text-grey-darkest text-sm mb-0 ml-1" for="labor_hours">{{ getFieldLabel(recordDetailFieldLabels, 'labor-hours')}}</label>
                                </div>
                                <div class="ml-2 leading-tight w-1/2 flex align-items-center">
                                    <input type="checkbox" id="dead_date" name="dead_date" v-model="form.dead_date" @change="checkRecordDetailData($event, 'dead-date')">
                                    <label class="text-grey-darkest text-sm mb-0 ml-1" for="dead_date">{{ getFieldLabel(recordDetailFieldLabels, 'dead-date')}}</label>
                                </div>
                            </div>
                            <div class="flex flex-wrap" v-if="form.record_detail_custom_fields.length > 0" v-for="(field, index) in form.record_detail_custom_fields">
                                <div class="flex leading-tight w-full mb-2">
                                    <input type="checkbox" style="margin-top: 3px;" :id="'record_detail_custom_fields'+field.id" name="record_detail_custom_fields" v-model="field.value" @change="checkRecordDetailCustomFieldData($event, field.id, index)">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center" :for="`record_detail_custom_fields`+field.id">{{ field.name }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-col w-full lg:w-1/3 lg:mx-1 mt-4 mt-lg-0">
                    <div class="rounded bg-white shadow-md">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Project Data</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="sales_status_id" name="sales_status_id" v-model="form.sales_status_id" @change="checkProjectData($event,'sales-status')">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="sales_status_id">{{ getFieldLabel(fieldLabels, 'sales-status')}}</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="marketing_status_id" name="marketing_status_id" v-model="form.marketing_status_id" @change="checkProjectData($event,'marketing-status')">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="marketing_status_id">{{ getFieldLabel(fieldLabels, 'marketing-status')}}</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="pre_bid" name="pre_bid" v-model="form.pre_bid" @change="checkProjectData($event,'pre-bid')">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="pre_bid">{{ getFieldLabel(fieldLabels, 'pre-bid')}}</label>
                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="bid_date" name="bid_date" v-model="form.bid_date" @change="checkProjectData($event,'bid-date')">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="bid_date">{{ getFieldLabel(fieldLabels, 'bid-date')}}</label>
                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="lead_from_id" name="lead_from_id" v-model="form.lead_from_id" @change="checkProjectData($event,'lead-source')">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="lead_from_id"> {{ getFieldLabel(fieldLabels, 'lead-source')}}</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="estimator_id" name="estimator_id" v-model="form.estimator_id" @change="checkProjectData($event,'estimator')">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="estimator_id">{{ getFieldLabel(fieldLabels, 'estimator')}}</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="account_manager_id" name="account_manager_id" v-model="form.account_manager_id" @change="checkProjectData($event,'account-manager')">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="account_manager_id">{{ getFieldLabel(fieldLabels, 'account-manager')}}</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="take_off_person_id" name="take_off_person_id" v-model="form.take_off_person_id" @change="checkProjectData($event,'take-off-person')">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="take_off_person_id"> {{ getFieldLabel(fieldLabels, 'take-off-person')}}</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="products_and_services_id" name="products_and_services_id" v-model="form.products_and_services_id" @change="checkProjectData($event,'products-and-services')">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="products_and_services_id">{{ getFieldLabel(fieldLabels, 'products-and-services')}}</label>

                                    <div class="text-red text-xs" >
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="client_profile_id" name="client_profile_id" v-model="form.client_profile_id"  @change="checkProjectData($event,'client-profile')">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="client_profile_id">{{ getFieldLabel(fieldLabels, 'client-profile')}}</label>

                                    <div class="text-red text-xs">
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="contract_type_id" name="contract_type_id" v-model="form.contract_type_id"  @change="checkProjectData($event,'contract-type')">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="contract_type_id"> {{ getFieldLabel(fieldLabels, 'contract-type')}}</label>

                                    <div class="text-red text-xs">
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" style="margin-top: 3px;" id="office_id" name="office_id" v-model="form.office_id"  @change="checkProjectData($event,'office')">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="office_id"> {{ getFieldLabel(fieldLabels, 'office')}}</label>

                                    <div class="text-red text-xs">
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row" v-if="form.custom_fields.length > 0" v-for="(field, index) in form.custom_fields">
                                    <input type="checkbox" style="margin-top: 3px;" :id="'custom_fields'+field.id" name="custom_fields" v-model="field.value" @change="checkCutomFieldData($event,field.id,index)">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           :for="`custom_fields`+field.id">{{ field.name }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-col w-full lg:w-1/3 lg:mx-1 mt-4 mt-lg-0">
                    <div class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Sales Activities</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div v-if="form.sales_behaviors.length > 0" v-for="(item,index) in form.sales_behaviors"
                                 class="flex mb-2 inline-block">
                                <input type="checkbox" :id="'sale_behavior'+item.id" style="margin-top: 3px;" name="sale_behavior" v-model="item.value">
                                <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center" :for="`sale_behavior`+item.id">{{
                                        item.name
                                    }}</label>
                            </div>
                            <div v-if="form.sales_behaviors.length === 0" class="mb-2">
                                <div class="text-grey-darkest text-sm">
                                    Your company does not currently have any sales activities.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rounded bg-white shadow-md">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Company Information</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" id="date" style="margin-top: 3px;" name="date" v-model="form.company_contacts">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="date">
                                        Company Contact
                                    </label>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" id="date" style="margin-top: 3px;" name="date" v-model="form.date">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="date">
                                        FollowUp
                                    </label>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <input type="checkbox" id="status" style="margin-top: 3px;" name="status" v-model="form.status">
                                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                           for="status">
                                        Status
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Form from "../../utils/form";
import axios from "axios";
import Swal from 'sweetalert2';

export default {
    name: "form_required_fields",
    props: ['currentTab', 'fieldLabels', 'labels', 'customFieldsLables', 'recordDetailCustomFieldLabels', 'recordDetailFieldLabels', 'recordDetailLabels'],
    data() {
        return {
            selects: {},
            form: new Form({
                name: false,
                bid_bond: false,
                address: false,
                city: false,
                state: false,
                zip: false,
                contact_name: false,
                contact_email: false,
                contact_phone: false,
                contact_cell: false,
                contact_fax: false,
                relate_and_connect_id: false,
                rules_of_engagement_id: false,
                find_problems_id: false,
                money_step_id: false,
                decision_process_id: false,
                base_bid: false,
                contract_amount: false,
                contract_date: false,
                gross_margin_percentage: false,
                labor_hours: false,
                dead_date: false,
                sales_status_id: false,
                marketing_status_id: false,
                pre_bid: false,
                bid_date: false,
                lead_from_id: false,
                estimator_id: false,
                account_manager_id: false,
                take_off_person_id: false,
                products_and_services_id: false,
                client_profile_id: false,
                contract_type_id: false,
                office_id: false,
                sales_behaviors: [],
                contact_company_id:false,
                custom_fields:[],
                company_contacts: false,
                date:false,
                status:false,
                currentTab:'new_file',
                record_detail_custom_fields: []
            }),
            required_fields: '',
            custom_fields_array:[],
            record_detail_custom_fields_array: [],
            loader: false
        };
    },
    components: {
    },
    async mounted(){
        this.loader = true;
        await this.fetchSalesBehaviors();
        await this.fetchCustomFields();
        await this.fetchRecordDetailCustomFields();
        await this.fetchRequiredFields();
    },
    methods: {
        async fetchSalesBehaviors() {
            let self = this;
            await axios.get(route('project.sales-behaviors')).then(({data}) => {
                data.data.map( res => {
                    let sales_behaviors = {
                        id: res.id,
                        name: res.name,
                        value: false
                    }
                    self.form.sales_behaviors.push(sales_behaviors)
                })
            }).catch((error) => {
                self.loader = false;
            });
        },
        fetchCodes() {
            axios.get(route('api.project.codes')).then(({data}) => {
                this.selects = data;
                if (this.reference) {
                    let ss = _.find(data.sales_status, {code: 'Pending'});
                    if (ss) this.form.sales_status_id = ss.id;
                }
            });
        },
        async fetchCustomFields(){
            let self = this;
            await axios.get(route('api.project-custom-field.index') + '?project=true').then(({data}) => {
                // self.form.custom_fields = data.data;
                data.data.map(res => {
                    let custom_fields = {
                        id: res.id,
                        name: res.label_value,
                        value: false
                    }
                    self.form.custom_fields.push(custom_fields)
                    self.custom_fields_array.push(custom_fields)
                })
            }).catch((error) => {
                self.loader = false;
            });
        },
        async fetchRequiredFields(){
            let self = this;
            self.loader = true;
            await axios.get(route('project.get-required-fields')).then(async ({data}) => {
                let response = data;
                if(self.currentTab === 'new_file' && response.new_file){
                    self.checkCustomfeild(self.form.custom_fields,response.new_file);
                    self.checkRecordDetailCustomField(self.form.record_detail_custom_fields, response.new_file);
                    self.form = await self.changeToBoolean(response.new_file);
                    if(self.form.custom_fields.length !== self.custom_fields_array.length){
                        await self.mapCustomFields();
                    }
                    if(self.form.record_detail_custom_fields.length !== self.record_detail_custom_fields_array.length) {
                        await self.mapRecordDetailCustomFields();
                    }
                }
                if (self.currentTab === 'pipeline'){
                    // if (response.new_file) {
                    //     let filterValue = await self.concatToPipeline(response.new_file)
                    //     if (self.form.custom_fields.length !== self.custom_fields_array.length){
                    //         await self.mapCustomFields();
                    //     }
                    //     let assignFilterDataToPipeline = await self.assignValueToFormData(response.pipeline, filterValue);
                    //     self.form = assignFilterDataToPipeline;
                    //     if (assignFilterDataToPipeline.custom_fields.length !== self.custom_fields_array.length){
                    //         await self.mapCustomFieldsOther(response.new_file.custom_fields);
                    //         await self.mapCustomFields();
                    //     }
                    // }
                    // else {
                        if (response.pipeline){
                            self.form = await self.changeToBoolean(response.pipeline)
                            if(self.form.custom_fields.length !== self.custom_fields_array.length) {
                                await self.mapCustomFields();
                            }
                            if(self.form.record_detail_custom_fields.length !== self.record_detail_custom_fields_array.length) {
                                await self.mapRecordDetailCustomFields();
                            }
                        }
                    // }
                }
                if (self.currentTab === 'contract' && response.contract){
                    // if (response.new_file) {
                    //     let filterValue = await self.concatToPipeline(response.new_file)
                    //     if (self.form.custom_fields.length !== self.custom_fields_array.length){
                    //         await self.mapCustomFields();
                    //     }
                    //     let assignFilterDataToContract = await self.assignValueToFormData(response.contract, filterValue);
                    //     self.form.name= assignFilterDataToContract.name ?? self.form.name;
                    //     self.form.bid_bond= assignFilterDataToContract.bid_bond ?? self.form.bid_bond;
                    //     self.form.address= assignFilterDataToContract.address ?? self.form.address;
                    //     self.form.city= assignFilterDataToContract.city ?? self.form.city;
                    //     self.form.state= assignFilterDataToContract.state ?? self.form.state;
                    //     self.form.zip= assignFilterDataToContract.zip ?? self.form.zip;
                    //     self.form.contact_name= assignFilterDataToContract.contact_name ?? self.form.contact_name;
                    //     self.form.contact_email= assignFilterDataToContract.contact_email ?? self.form.contact_email;
                    //     self.form.contact_phone= assignFilterDataToContract.contact_phone ?? self.form.contact_phone;
                    //     self.form.contact_cell= assignFilterDataToContract.contact_cell ?? self.form.contact_cell;
                    //     self.form.contact_fax= assignFilterDataToContract.contact_fax ?? self.form.contact_fax;
                    //     self.form.relate_and_connect_id= assignFilterDataToContract.relate_and_connect_id ?? self.form.relate_and_connect_id;
                    //     self.form.rules_of_engagement_id= assignFilterDataToContract.rules_of_engagement_id ?? self.form.rules_of_engagement_id;
                    //     self.form.find_problems_id= assignFilterDataToContract.find_problems_id ?? self.form.find_problems_id;
                    //     self.form.money_step_id= assignFilterDataToContract.money_step_id ?? self.form.money_step_id;
                    //     self.form.decision_process_id= assignFilterDataToContract.decision_process_id ?? self.form.decision_process_id;
                    //     self.form.base_bid= assignFilterDataToContract.base_bid ?? self.form.base_bid;
                    //     self.form.contract_amount= assignFilterDataToContract.contract_amount ?? self.form.contract_amount;
                    //     self.form.contract_date= assignFilterDataToContract.contract_date ?? self.form.contract_date;
                    //     self.form.gross_margin_percentage= assignFilterDataToContract.gross_margin_percentage ?? self.form.gross_margin_percentage;
                    //     self.form.labor_hours= assignFilterDataToContract.labor_hours ?? self.form.labor_hours;
                    //     self.form.dead_date= assignFilterDataToContract.dead_date ?? self.form.dead_date;
                    //     self.form.sales_status_id= assignFilterDataToContract.sales_status_id ?? self.form.sales_status_id;
                    //     self.form.marketing_status_id= assignFilterDataToContract.marketing_status_id ?? self.form.marketing_status_id;
                    //     self.form.pre_bid= assignFilterDataToContract.pre_bid ?? self.form.pre_bid;
                    //     self.form.bid_date= assignFilterDataToContract.bid_date ?? self.form.bid_date;
                    //     self.form.lead_from_id= assignFilterDataToContract.lead_from_id ?? self.form.lead_from_id;
                    //     self.form.estimator_id= assignFilterDataToContract.estimator_id ?? self.form.estimator_id;
                    //     self.form.account_manager_id= assignFilterDataToContract.account_manager_id ?? self.form.account_manager_id;
                    //     self.form.take_off_person_id= assignFilterDataToContract.take_off_person_id ?? self.form.take_off_person_id;
                    //     self.form.products_and_services_id= assignFilterDataToContract.products_and_services_id ?? self.form.products_and_services_id;
                    //     self.form.client_profile_id= assignFilterDataToContract.client_profile_id ?? self.form.client_profile_id;
                    //     self.form.contract_type_id= assignFilterDataToContract.contract_type_id ?? self.form.contract_type_id;
                    //     self.form.office_id= assignFilterDataToContract.office_id ?? self.form.office_id;
                    //     self.form.sales_behaviors= assignFilterDataToContract.sales_behaviors ?? self.form.sales_behaviors;
                    //     self.form.contact_company_id=assignFilterDataToContract.contact_company_id ?? self.form.contact_company_id;
                    //     self.form.custom_fields=assignFilterDataToContract.custom_fields ?? self.form.custom_fields;
                    //     self.form.date=assignFilterDataToContract.date ?? self.form.date;
                    //     self.form.status=assignFilterDataToContract.status ?? self.form.status;
                    //     self.form.company_contacts=assignFilterDataToContract.company_contacts ?? self.form.company_contacts;
                    //     self.form.currentTab=assignFilterDataToContract.currentTab;
                    //     if (assignFilterDataToContract.custom_fields.length !== self.custom_fields_array.length){
                    //         await self.mapCustomFieldsOther(response.new_file.custom_fields);
                    //         await self.mapCustomFields();
                    //     }
                    // }
                    // else {
                        if (response.contract){
                            self.form = await self.changeToBoolean(response.contract)
                            if(self.form.custom_fields.length !== self.custom_fields_array.length) {
                                await self.mapCustomFields();
                            }
                            if(self.form.record_detail_custom_fields.length !== self.record_detail_custom_fields_array.length) {
                                await self.mapRecordDetailCustomFields();
                            }
                        }
                    // }
                }
                if (self.currentTab === 'dead'){
                    // if (response.new_file) {
                    //     let filterValue = await self.concatToPipeline(response.new_file)
                    //     if (self.form.custom_fields.length !== self.custom_fields_array.length){
                    //         await self.mapCustomFields();
                    //     }
                    //     let assignFilterDataToLost = await self.assignValueToFormData(response.dead, filterValue);
                    //     self.form = assignFilterDataToLost;
                    //     if (assignFilterDataToLost.custom_fields.length !== self.custom_fields_array.length){
                    //         await self.mapCustomFieldsOther(response.new_file.custom_fields);
                    //         await self.mapCustomFields();
                    //     }
                    // }
                    // else {
                        if (response.dead){
                            self.form = await self.changeToBoolean(response.dead)
                            if(self.form.custom_fields.length !== self.custom_fields_array.length) {
                                await self.mapCustomFields();
                            }
                            if(self.form.record_detail_custom_fields.length !== self.record_detail_custom_fields_array.length) {
                                await self.mapRecordDetailCustomFields();
                            }
                        }
                    // }
                }
                self.loader = false;
            }).catch((error) => {
                self.loader = false;
            });
        },
        async mapCustomFields(){
            let self = this;
            let formCustomFields = self.form.custom_fields;
            let arrayCustomFields = self.customFieldsLables;
            let result = arrayCustomFields.filter(({ id }) => !formCustomFields.find(o => o.id == id));
            result.map(res => {
                let custom_fields = {
                    id: res.id,
                    name: res.name,
                    value: false
                }
                self.form.custom_fields.push(custom_fields)
            })

            let formAfterPushCustomFields = self.form.custom_fields;
            self.form.custom_fields = formAfterPushCustomFields.filter(({ id }) => arrayCustomFields.find(o => o.id == id));
        },

        async mapCustomFieldsOther(arrayCustomFields){
            let self = this;
            let formCustomFields = self.form.custom_fields;
            let result = arrayCustomFields.filter(({ id }) => !formCustomFields.find(o => o.id == id));
            result.map(res => {
                let custom_fields = {
                    id: res.id,
                    name: res.name,
                    value: res.value
                }
                self.form.custom_fields.push(custom_fields)
            })
        },


        async assignValueToFormData(response, filterValue){
            let temp =[];
            for await (const [key, value] of Object.entries(response)) {
                if(typeof value === 'boolean' || typeof value === 'string') {
                    if(key === 'currentTab') {
                        temp.push({[key]: value});
                    }
                    else {
                        let filter = filterValue.some(function (val) {
                            return Object.keys(val)[0] === key
                        });
                        if(filter) {
                            temp.push({[key]: true})
                        }
                        else {
                            temp.push({[key]: (value === true || value === 'true')})
                        }
                    }
                }else{
                    if(key === 'sales_behaviors'){
                        temp.push({[key]:value.map(item => {
                            return  {
                                id :item.id,
                                name :item.name,
                                value : (item.value === true || item.value === 'true')
                            }
                        })})
                    }else{
                        temp.push({[key]:value.map(item => {
                            let filterObject = filterValue.some(function (val) {
                                if(typeof Object.values(val)[0] !== 'boolean' && typeof Object.values(val)[0] !== 'string') {
                                    return  Object.values(val)[0].some((filterArr)=>item.id === filterArr.id)
                                }
                            })
                            if(filterObject){
                                return  {
                                    id :item.id,
                                    name :item.name,
                                    value : false
                                }
                            }else{
                                return  {
                                    id :item.id,
                                    name :item.name,
                                    value : (item.value === true || item.value === 'true')
                                }
                            }})
                        })
                    }
                }
            }
            return await Object.assign({}, ...temp );
        },
        async changeToBoolean(data) {
            let temp =[];
            for await (const [key, value] of Object.entries(data)) {
                if(typeof value === 'boolean' || typeof value === 'string') {
                    if(key === 'currentTab') {
                        temp.push({[key]: value});
                    }
                    else {
                        temp.push({[key]: (value === true || value === 'true')});
                    }
                }
                else {
                    temp.push({[key]: value.map(item => {
                        return  {
                            id :item.id,
                            name :item.name,
                            value : (item.value === true || item.value === 'true')
                        }
                    })});
                }
            }
            return Object.assign({}, ...temp );
        },
        async concatToPipeline(data) {
            let temp = [];
            for await (const [key, value] of Object.entries(data)) {
                if((typeof value === 'boolean' && value === true) || typeof value === 'string' && value === 'true') {
                    temp.push({[key]: value})
                }
                else {
                    let filterValue = value.filter(item => item.value === true);
                    if(filterValue.length > 0){
                        temp.push({[key]:filterValue})
                    }
                }
            }
            return temp;
        },
        saved() {
            let self = this;
            let payload = {
                name: self.form.name,
                bid_bond: self.form.bid_bond,
                address: self.form.address,
                city: self.form.city,
                state: self.form.state,
                zip: self.form.zip,
                contact_name: self.form.contact_name,
                contact_email: self.form.contact_email,
                contact_phone: self.form.contact_phone,
                contact_cell: self.form.contact_cell,
                contact_fax: self.form.contact_fax,
                relate_and_connect_id: self.form.relate_and_connect_id,
                rules_of_engagement_id: self.form.rules_of_engagement_id,
                find_problems_id: self.form.find_problems_id,
                money_step_id: self.form.money_step_id,
                decision_process_id: self.form.decision_process_id,
                base_bid: self.form.base_bid,
                contract_amount: self.form.contract_amount,
                contract_date: self.form.contract_date,
                gross_margin_percentage: self.form.gross_margin_percentage,
                labor_hours: self.form.labor_hours,
                dead_date: self.form.dead_date,
                sales_status_id: self.form.sales_status_id,
                marketing_status_id: self.form.marketing_status_id,
                pre_bid: self.form.pre_bid,
                bid_date: self.form.bid_date,
                lead_from_id: self.form.lead_from_id,
                estimator_id: self.form.estimator_id,
                account_manager_id: self.form.account_manager_id,
                take_off_person_id: self.form.take_off_person_id,
                products_and_services_id: self.form.products_and_services_id,
                client_profile_id: self.form.client_profile_id,
                contract_type_id: self.form.contract_type_id,
                office_id: self.form.office_id,
                sales_behaviors: self.form.sales_behaviors,
                contact_company_id:self.form.contact_company_id,
                custom_fields: self.form.custom_fields,
                record_detail_custom_fields: self.form.record_detail_custom_fields,
                company_contacts: self.form.company_contacts,
                date:self.form.date,
                status:self.form.status,
                currentTab:self.currentTab
            }
            axios.post(route('project.required-fields'), payload).then(({data}) => {
                this.fireSuccessToast('Successfully Saved!');
            });
        },
        fireSuccessToast(message) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            Toast.fire({
                type : 'success',
                title: message,
            });
        },
        fireErrorToast(message) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            Toast.fire({
                type : 'error',
                title: message,
            });
        },
        checkCustomfeild(customfeild,respons) {

            if (customfeild.length > 0 && !respons.hasOwnProperty('custom_fields')) {

                respons.custom_fields = customfeild

            } else if (respons.hasOwnProperty('custom_fields')) {

                let match = false;
                for (const customfeildKey in customfeild) {
                    for (const resfeildKeyKey in respons.custom_fields) {
                        if (customfeild[customfeildKey].name == respons.custom_fields[resfeildKeyKey].name) {
                            match = true
                        }
                    }
                    if (match === false) {
                        respons.custom_fields = customfeild[customfeildKey]
                    }

                }
            }
        },
        checkProjectData(event,field){
            this.$nextTick(() => {
                if(event.target.checked){
                    let projectDataField = _.filter(this.labels, ['actual_label_slug', field]);
                    if (!projectDataField[0].label_view){
                        this.fireErrorToast(projectDataField[0].current_label+ ' is hidden in Edit Field Labels and cannot be required');
                        this.form[event.target.id] = false;
                    }
                }
            })
        },
        checkCutomFieldData(event,fieldId,index){
            this.$nextTick(() => {
                if(event.target.checked){
                    let customProjectField =this.customFieldsLables.find((lable)=> lable.id == fieldId)
                    if (customProjectField !== undefined){
                        if (!customProjectField.label_view){
                            this.fireErrorToast(customProjectField.current_label+ ' is hidden in Edit Field Labels and cannot be required');
                            this.form.custom_fields[index].value = false;
                        }
                    }
                }
            })
        },
        async fetchRecordDetailCustomFields() {
            let self = this;
            await axios.get(route('api.record-detail-custom-field.index') + '?project=true').then(({data}) => {
                data.data.map(res => {
                    let custom_fields = {
                        id: res.id,
                        name: res.label_value,
                        value: false
                    }
                    self.form.record_detail_custom_fields.push(custom_fields)
                    self.record_detail_custom_fields_array.push(custom_fields)
                })
            });
        },
        checkRecordDetailCustomField(customField, response) {
            if(customField.length > 0 && !response.hasOwnProperty('record_detail_custom_fields')) {
                response.record_detail_custom_fields = customField;
            }
            else if(response.hasOwnProperty('record_detail_custom_fields')) {
                let match = false;
                for(const customFieldKey in customField) {
                    for(const responseFieldKey in response.record_detail_custom_fields) {
                        if(customField[customFieldKey].name === response.record_detail_custom_fields[responseFieldKey].name) {
                            match = true;
                        }
                    }
                    if(match === false) {
                        response.record_detail_custom_fields = customField[customFieldKey]
                    }
                }
            }
        },
        async mapRecordDetailCustomFields() {
            let self = this;
            let formCustomFields = self.form.record_detail_custom_fields;
            let arrayCustomFields = self.recordDetailCustomFieldLabels;
            let result = arrayCustomFields.filter(({ id }) => !formCustomFields.find(o => o.id == id));
            result.map(res => {
                let customFields = {
                    id: res.id,
                    name: res.name,
                    value: false
                }
                self.form.record_detail_custom_fields.push(customFields)
            });

            let formAfterPushCustomFields = self.form.record_detail_custom_fields;
            self.form.record_detail_custom_fields = formAfterPushCustomFields.filter(({ id }) => arrayCustomFields.find(o => o.id == id));
        },
        async mapRecordDetailCustomFieldsOther(arrayCustomFields) {
            let self = this;
            let formCustomFields = self.form.record_detail_custom_fields;
            let result = arrayCustomFields.filter(({ id }) => !formCustomFields.find(o => o.id == id));
            result.map(res => {
                let customFields = {
                    id: res.id,
                    name: res.name,
                    value: res.value
                }
                self.form.record_detail_custom_fields.push(customFields);
            })
        },
        checkRecordDetailCustomFieldData(event, fieldId, index) {
            this.$nextTick(() => {
                if(event.target.checked) {
                    let customProjectField = this.recordDetailCustomFieldLabels.find((label)=> label.id == fieldId)
                    if(customProjectField !== undefined) {
                        if(!customProjectField.label_view) {
                            this.fireErrorToast(customProjectField.current_label + ' is hidden in Edit Field Labels and cannot be required');
                            this.form.record_detail_custom_fields[index].value = false;
                        }
                    }
                }
            })
        },
        checkRecordDetailData(event, field) {
            this.$nextTick(() => {
                if(event.target.checked) {
                    let recordDetailField = _.filter(this.recordDetailLabels, ['actual_label_slug', field]);
                    if(!recordDetailField[0].label_view) {
                        this.fireErrorToast(recordDetailField[0].current_label+ ' is hidden in Edit Field Labels and cannot be required');
                        this.form[event.target.id] = false;
                    }
                }
            })
        }
    },

}
</script>

<style scoped>
.loader-center{
    position: absolute;
    top: 35%;
    z-index: 1
}
</style>
